module.exports = __webpack_public_path__ + "fonts/hlishu.f1bd13e0.ttf";